import { handleQuickshopModal } from "../modal/handleQuickshopModal";

const queryPageNumber = window.location.search
  .substr(1)
  .split("&")
  .filter((item) => {
    return item.includes("page-index");
  })[0];
let pageNumber = queryPageNumber ? Number(queryPageNumber.split("=")[1]) : 1;

$("#js-collection-wrap").on("click", "#js-paginate-collection", function (e) {
  pageNumber = pageNumber + 1;
  e.preventDefault();
  const url = $(this).attr("href");
  $.get(url)
    .done((res) => {
      const html = $(res);
      const nextResults = $("#js-collection-listings", html);

      if (nextResults.length > 0 && nextResults[0].children.length > 0) {
        $("#js-collection-listings").append($(nextResults).html());

        $(".collection__paginate").html(
          $(".collection__paginate--center", html).html()
        );

        $("#js-paginate-wrap").html($("#js-paginate-wrap", html).html());
        history.replaceState(
          null,
          null,
          `${window.location.pathname}?page-index=${pageNumber}`
        );

        handleQuickshopModal();
      }
    })
    .catch((err) => console.error("There was an error: ", err));
});

if (
  window.location.pathname.includes("collections") &&
  window.location.search.includes("page-index")
) {
  // start the loop at 2 as we will never need to return the first page
  for (let i = 2; i <= pageNumber; i++) {
    $.get(`${window.location.pathname}?page=${i}`).done((res) => {
      const html = $(res);
      const nextResults = $("#js-collection-listings", html);

      if (nextResults.length > 0 && nextResults[0].children.length > 0) {
        $("#js-collection-listings").append($(nextResults).html());

        $(".collection__paginate").html(
          $(".collection__paginate--center", html).html()
        );

        $("#js-paginate-wrap").html($("#js-paginate-wrap", html).html());
        handleQuickshopModal();
      }
    });
  }
}

$(".list-radio-buttons input").on("click", function () {
  // const inputValue = $(this).val().split(" ").join("-");
  // history.pushState(
  //   null,
  //   null,
  //   `${window.location.pathname}/${inputValue}?page-index=${pageNumber}`
  // );
  pageNumber = 1;
});
